/**
 * Builds the full leave/LeavePolicySetup payload.
 * Every field is always sent; unused fields are null based on leave type.
 *
 * Non comp-off: standard limits/credit filled, CompOffPolicyConfig = null
 * Comp-off: standard limits/credit = null; combo-off saved via LeavePolicyComboSetup
 */
export function buildLeavePolicyPayload(
	values,
	{ isCompOffLeave, leavePolicyId, yearId, masterData }
) {
	const leaveStartMonthId =
		masterData?.CompanyDetails?.[0]?.LeaveStartMonthId || 1;
	const currentYear = new Date().getFullYear();
	const isCalendarYear = leaveStartMonthId === 1;

	const payload = {
		LeavePolicyId: leavePolicyId || 0,
		LeaveTypeId: values.leaveTypeId ?? null,
		LeavePolicyGroupId: values.LeavePolicyGroupId ?? null,
		PaidLeaveCount: 0,
		UnpaidLeaveCount: 0,
		MonthlyLimit: null,
		YearlyLimit: null,
		InHours: null,
		IsPaidLeave: Boolean(values.paid),
		IsCarryForward: null,
		IsEnCashable: null,
		IsAllowCredit: null,
		LeaveCreditLimit: null,
		YearId: yearId ?? null,
		CalendarYear: isCalendarYear ? currentYear : 0,
		DataStatus: 1,
		CreatedBy: 1,
		ModifiedBy: 1,
		CompOffPolicyConfig: null,
	};

	if (isCompOffLeave) {
		return payload;
	}

	payload.MonthlyLimit =
		values.monthlyLimit != null && values.monthlyLimit !== ""
			? String(values.monthlyLimit)
			: null;
	payload.YearlyLimit =
		values.yearlyLimit != null && values.yearlyLimit !== ""
			? String(values.yearlyLimit)
			: null;
	payload.InHours = values.unit === "hours";
	payload.IsCarryForward = Boolean(values.carryForward);
	payload.IsEnCashable = Boolean(values.encashable);
	payload.IsAllowCredit = values.credit === "monthly";
	payload.LeaveCreditLimit =
		values.creditLimit != null && values.creditLimit !== ""
			? String(values.creditLimit)
			: null;

	return payload;
}
